<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data () {
    return {
      meta: {
        name: 'viewport',
        content: 'width=device-width,initial-scale=1.0'
      }
    }
  },
  mounted () {
    if (this.isMobile()) {
      this.appendMeta()
    }
  },
  methods: {
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    appendMeta () {
      let head = document.getElementsByTagName('head')
      let meta = document.createElement('meta')
      meta.name = 'viewport',
      meta.content = 'width=device-width,initial-scale=1.0,user-scalable=no;',
      head[0].appendChild(meta)
    }
  }

}
</script>

<style>
 @import './assets/fonts/font.css'
</style>



// WEBPACK FOOTER //
// src/App.vue